module.exports = __webpack_public_path__ + "img/forgot-password-v2.fd87bbb3.svg";